import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { getClient, getGeonorgeToken } from '../../constants/api';
import { GeonorgeContext } from './GeonorgeContext';

const GeonorgeProvider = ({ children }) => {
    const [token, setToken] = useState('');
    const [expirationTime, setExpirationTime] = useState('');
    const [initialized, setInitialized] = useState(false);
    const refreshTimerRef = useRef(null);

    const hentToken = useCallback(async () => {
        try {
            const client = getClient();
            const response = await client.get(getGeonorgeToken());
            const { data } = response;
            setToken(data.result.token);
            setExpirationTime(data.result.expiry);

            // Automatisk refresh av token 5 minutter før utløp
            const expiryDate = new Date(data.result.expiry);
            const now = new Date();
            const timeUntilExpiry = expiryDate.getTime() - now.getTime();
            const refreshTime = Math.max(timeUntilExpiry - 5 * 60 * 1000, 0); // 5 minutter før, eller umiddelbart

            if (refreshTimerRef.current) {
                clearTimeout(refreshTimerRef.current);
            }

            if (refreshTime > 0) {
                const timer = setTimeout(() => {
                    hentToken();
                }, refreshTime);
                refreshTimerRef.current = timer;
            }
        } catch (error) {
            console.error('Feil ved henting av Geonorge token:', error);
            setToken('');
            setExpirationTime('');
        } finally {
            setInitialized(true);
        }
    }, []);

    useEffect(() => {
        hentToken();
        return () => {
            if (refreshTimerRef.current) {
                clearTimeout(refreshTimerRef.current);
            }
        };
    }, [hentToken]);

    const contextValue = useMemo(
        () => ({
            token,
            expirationTime,
            initialized,
        }),
        [token, expirationTime, initialized]
    );

    return <GeonorgeContext.Provider value={contextValue}>{children}</GeonorgeContext.Provider>;
};

export default GeonorgeProvider;
